<template lang="pug">
div.body-lo
  div.modal-header
    span.lo-modal-title XEM GIẢI THÍCH CHI TIẾT TỪNG CÂU HỎI
    span.lo-modal-btn-close.material-icons(@click="closePopupPayment") close
  div.modal-body
    div.reg-content Để xem giải thích chi tiết từng câu hỏi cho bài tập này bạn cần thanh toán:
    div.board-payment
      .text-honey Hũ mật ong
      .number-honey 
        span {{$mycontroller.numberWithCommas(amount)}}
        img(src="../../../../assets/images/achieve/ic_honeyJars.png")
  div.modal-footer.lo-custom-footer
    div.row
      div.col-md-12.col-12.text-center
        a.lo-btn-continue.lo-popup-pc.btn(@click='continuteConfirmPayment()') Xác nhận
</template>
<script>
export default {
  props: {
    continutePayment: Function,
    amount: Number,
    qCurrent: Number
  },
  methods: {
    continuteConfirmPayment() {
      this.continutePayment({return: this.amount, qCurrent: this.qCurrent})
      this.$nextTick(() => {
        this.$emit('close')
      })
    },
    closePopupPayment() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss">
:root {
  // Color 
  --color-background-button: #FFD311;
}
.body-lo {
  margin-left: 5px;
  margin-right: 5px;
  background-color: white;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px;
  .lo-modal-title {
    font-family: 'adobe-clean', sans-serif;
    float: left;
    font-size: 17px;
  }
  .lo-modal-btn-close {
    float: right;
    &:hover {
      cursor: pointer;
    }
  }
  .reg-content{
      span{color: #333333; font-size: 15px; font-weight: bold;}
  }
  .board-payment{background: #FFFFFF 0% 0% no-repeat padding-box; box-shadow: 0px 3px 3px #00000029; border: 3px solid #9F6A28; border-radius: 10px; margin-top: 16px; margin-bottom: 32px; padding: 11px;  text-align: center;
    .text-honey{font-size: 15px; color: #333333; margin-bottom: 11px;}
    .number-honey{
      span {font-size: 24px; font-weight: bold; color: #9F6A28; display: inline-block; margin-right: 16px;vertical-align: bottom;}
      img{width: 24px;}
    }
  }
  .lo-body-title {
    color: var(--color-type-selected);
    margin-bottom: 0;
    padding-bottom: 3px;
  }
  .lo-btn-continue {
    background: var(--color-background-button);
    color: #000;
    text-transform: none;
    font-size: 13px;
    font-family: 'adobe-clean', sans-serif;
    border: 1px solid #FFD311;
    border-radius: 5px;
    // box-shadow: 0px 0px 0px;
    width: 160px;
    padding-left: 0;
    padding-right: 0;
    margin-top: 0 !important;
    margin-bottom: 15px;
  }
  .lo-popup-pc{color: #23180A; font-size: 14px;}
  .lo-btn-back {
    background: white;
    color: black;
    text-transform: none;
    font-size: 13px;
    font-family: 'adobe-clean', sans-serif;
    border: 1px solid #FFD311;
    border-radius: 5px;
    // box-shadow: 0px 0px 0px;
    width: 160px;
    margin-top: 0 !important;
  }
  .lo-custom-footer {
    padding: 0;
    border: 0;
  }
// cellphones 
@media (max-width: 414px) {
  .lo-btn-continue {
    float: none;
    margin-left: auto;
    width: 115px;
  }
  .lo-btn-back {
    float: right;
    margin-right: 40px;
    width: 115px;
  }
}
}
</style>



// WEBPACK FOOTER //
// popupPayment.vue?5a2e33f1